import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GalleryModalComponent } from './modals/gallery-modal/gallery-modal.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { BodyTypeWarnComponent } from './modals/body-type-warn/body-type-warn.component';
import { AddonComponent } from './addon/addon.component';
import { StatusComponent } from './status/status.component';
import { TemplateModalComponent } from './modals/template-modal/template-modal.component';
import { ActivityLogComponent } from './activity-log/activity-log.component';
import { ActivitySkeletonComponent } from './activity-skeleton/activity-skeleton.component';
import { AudioRecorderComponent } from './audio-recorder/audio-recorder.component';
import { VideoRecorderComponent } from './video-recorder/video-recorder.component';
import { MediaSectionComponent } from './media-section/media-section.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { LocalFileSelectorComponent } from './local-file-selector/local-file-selector.component';

@NgModule({
  declarations: [
    GalleryModalComponent,
    SidebarComponent,
    LoaderComponent,
    ConfirmModalComponent,
    BodyTypeWarnComponent,
    AddonComponent,
    StatusComponent,
    TemplateModalComponent,
    ActivityLogComponent,
    ActivitySkeletonComponent,
    AudioRecorderComponent,
    VideoRecorderComponent,
    MediaSectionComponent,
    LocalFileSelectorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxFileDropModule,
    ReactiveFormsModule,
    NgSelectModule,
    ModalModule.forRoot(),
    TranslateModule.forChild({
      extend: true
    })
  ],
  exports: [
    GalleryModalComponent,
    SidebarComponent,
    LoaderComponent,
    AddonComponent,
    StatusComponent,
    ActivityLogComponent,
    AudioRecorderComponent,
    VideoRecorderComponent,
    MediaSectionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CommonCompModule {}
